var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('Header'),_c('Hero'),_c('Demo'),_c('Examples'),_c('Testimonials'),_c('About'),_c('Pricing'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }